import type { Node } from "interfaces/schemas";
import type { TreeApi, NodeApi } from "@hogartrabe/react-arborist-vrh";
import { walkTree } from "utils/treeUtils/walkTree";

export const expandLevel = (
  openMap: Record<string, boolean> | null,
  treeApi: TreeApi<Node>,
) => {
  if (openMap === null) {
    throw new Error("Open map is not initialized. Cannot expand level.");
  }
  if (!treeApi) {
    throw new Error("Tree API is not available. Cannot expand level.");
  }
  const rootNode = treeApi.root.children?.[0];
  if (!rootNode) {
    throw new Error("Root node is missing. Cannot expand level.");
  }
  const newOpenMap = { ...openMap };
  const nodesToOpen = new Set<NodeApi<Node>>();

  // Assigned 1000 as a value which will most likely never actually be surpased by actual node levels
  let currentMinLevel = 1000;

  walkTree({
    node: rootNode,
    childAccessor: (node) => node.children,
    skipChildren: (node) => !node.isOpen,
    callback: (node) => {
      if (
        !node.isOpen &&
        node.children &&
        node.children.length > 0 &&
        node.level <= currentMinLevel
      ) {
        if (node.level === currentMinLevel) {
          nodesToOpen.add(node);
        } else {
          currentMinLevel = node.level;
          nodesToOpen.clear();
          nodesToOpen.add(node);
        }
      }
    },
  });
  if (currentMinLevel < 1000) {
    nodesToOpen.forEach((node) => {
      node.open();
      delete newOpenMap[node.id];
    });
  }
  return newOpenMap;
};
